import { LocalizableObjectLayer } from '@techwan/mapping';

export class DeploymentPointsLayer extends LocalizableObjectLayer {
  constructor(name?: string) {
    super(null, { name });
  }
}
